import { BlockEditorInput } from "@babackapp/blocks-editor/block-editor-input";
import { TranslatableField } from "@babackapp/ui/components/translatable-field";
import { useVariablesDictionary } from "@babackapp/variables-registry";
import { useTranslation } from "react-i18next";
import useCurrentShopSuspense from "../../hooks/use-current-shop-suspense";

interface WorkflowSubjectEditorProps {
  value: Record<string, string>;
  onChange: (value: Record<string, string>) => void;
}

export function WorkflowSubjectEditor({
  value,
  onChange,
}: WorkflowSubjectEditorProps) {
  const { t } = useTranslation("trackoffice");
  const { data: shop } = useCurrentShopSuspense();
  const { variables } = useVariablesDictionary();

  const locales = shop.trackingPreferences?.availableLocales ?? ["fr"];
  const defaultLocale =
    shop.trackingPreferences?.notificationsDefaultLocale ?? "fr";

  return (
    <div className="flex items-center gap-3">
      <label className="text-sm font-medium shrink-0">
        {t("workflowsEditor.emailCustomization.subject", "Email subject")}
      </label>
      <TranslatableField
        className="flex-1 min-w-0"
        value={value}
        onChange={onChange}
        locales={locales}
        defaultLocale={defaultLocale}
        placeholder={t(
          "workflowsEditor.emailCustomization.subjectPlaceholder",
          "Custom subject...",
        )}
        renderInput={({ value: inputValue, onChange: inputOnChange, placeholder }) => (
          <BlockEditorInput
            value={inputValue}
            onChange={inputOnChange}
            placeholder={placeholder}
            variables={variables}
            outputFormat="text"
          />
        )}
      />
    </div>
  );
}
